"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vehicle = void 0;
const saleStatus_1 = require("./saleStatus");
const condition_1 = require("./condition");
const engineAspiration_1 = require("./engineAspiration");
const engineFuel_1 = require("./engineFuel");
const engineFuelInduction_1 = require("./engineFuelInduction");
const transmission_1 = require("./transmission");
const color_1 = require("./color");
const marketSegment_1 = require("./marketSegment");
const seller_1 = require("./seller");
const title_1 = require("./title");
const featureTag_1 = require("./featureTag");
const bodyType_1 = require("./bodyType");
const bodyTypeSearch_1 = require("./bodyTypeSearch");
const driveType_1 = require("./driveType");
const size_1 = require("./size");
const weightClass_1 = require("./weightClass");
const sortOption_1 = require("./sortOption");
const decodeMethod_1 = require("./decodeMethod");
const specification_1 = require("./specification");
const country_1 = require("./country");
const make_1 = require("./make");
const price_1 = require("./price");
const seats_1 = require("./seats");
const deal_1 = require("./deal");
const seoPopularCategory_1 = require("./seoPopularCategory");
exports.vehicle = {
    saleStatus: saleStatus_1.saleStatus,
    condition: condition_1.condition, getConditionByName: condition_1.getConditionByName,
    engineAspiration: engineAspiration_1.engineAspiration, getEngineAspirationName: engineAspiration_1.getEngineAspirationName,
    transmission: transmission_1.transmission, getTransmission: transmission_1.getTransmission,
    fuelType: engineFuel_1.fuelType, getFuelTypeName: engineFuel_1.getFuelTypeName, getFuelType: engineFuel_1.getFuelType,
    fuelInduction: engineFuelInduction_1.fuelInduction, getFuelInductionName: engineFuelInduction_1.getFuelInductionName,
    driveType: driveType_1.driveType,
    colorGroup: color_1.colorGroup,
    marketSegment: marketSegment_1.marketSegment,
    sellerType: seller_1.sellerType,
    titleType: title_1.titleType,
    featureTag: featureTag_1.featureTag,
    bodyType: bodyType_1.bodyType,
    bodyTypeSearch: bodyTypeSearch_1.bodyTypeSearch,
    size: size_1.size,
    weightClass: weightClass_1.weightClass,
    SortEnum: sortOption_1.SortEnum, sortOption: sortOption_1.sortOption,
    decodeMethodOption: decodeMethod_1.decodeMethodOption,
    specification: specification_1.specification, hdSpecification: specification_1.hdSpecification,
    country: country_1.country,
    popularMake: make_1.popularMake,
    exotic: make_1.exotic, luxury: make_1.luxury, sport: make_1.sport,
    price: price_1.price,
    seats: seats_1.seats,
    deal: deal_1.deal,
    seoPopularCategory: seoPopularCategory_1.seoPopularCategory,
};
